<template>
  <div class="convert-list">
    <template v-for="(item, idx) in navConvertList">
      <div :key="idx" class="convert-type inner">{{ item.type }}</div>
      <ul :key="`a${idx}`" class="inner g_clr">
        <li v-for="(item2, idx2) in item.list" :key="item2.name" :class="{last: (idx2 + 1) % 5 === 0 }">
          <a :class="{'default-color': item2.defaultColor}" @click="clickItem(item2.routeName)">
            <span class="home_icons" :class="item2.className" />
            <span class="tit">{{ item2.name }}</span>
            <em v-if="item2.isHot" class="hot home_icons home_icon_hot" />
          </a>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { HOME_CONVERT_NAV_LIST } from '@/config/config'
import { strictExtend } from '@shared/utils/base/index.js'

export default {
  name: 'ConvertList',

  data () {
    return {
      navConvertList: strictExtend(HOME_CONVERT_NAV_LIST)
    }
  },

  methods: {
    clickItem (routeName) {
      if (!routeName) return

      this.$router.push({
        name: routeName
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .convert-list {
    li {  box-sizing: content-box;  float: left;  width: 216px; height: 216px;  margin: 20px 20px 0 0; overflow: hidden; font-size: 18px; text-align: center; background: rgba(255, 255, 255, 1); border: 2px solid transparent; border-radius: 4px; box-shadow: 0 0 16px 0 rgba(185, 204, 238, 0.4);
      &:hover { border: 2px solid rgba(84, 142, 248, 1); }
      a { position: relative; display: inline-block; width: 100%; height: 100%; padding-top: 59px;
        .tit { display: block; margin-top: 5px; }
        &:hover { color: $primary-color; }
      }
      .default-color { color: $primary-color; }
    }
    .last { margin-right: 0; }
    .hot { position: absolute; top: -2px; right: -2px; }
  }
  .convert-type { height: 50px; margin-top: 20px; font-size: 16px; line-height: 50px; color: $primary-color; text-align: center; background: $sub-color; }

</style>
